import {AfterViewInit, Component, OnDestroy, SimpleChanges} from '@angular/core';
import {StaticThresholdAlarmParameters} from '../../../../../../../shared/classes/alarms/alarm-parameters/static-threshold-alarm-parameters';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {AlarmParameterDefaultForm} from '../../../../../../../shared/classes/alarms/alarm-parameters/alarm-parameter-default-form';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-alarm-parameter-form-static-threshold',
  templateUrl: './alarm-parameters-form-static-threshold.component.html',
  styleUrls: ['./alarm-parameters-form-static-threshold.component.css']
})
export class AlarmParametersFormStaticThresholdComponent extends AlarmParameterDefaultForm implements AfterViewInit, OnDestroy {

  params: StaticThresholdAlarmParameters;
  paramsChangeSubsc: Subscription;
  typeOptions = ['min', 'max'];

  constructor(protected formBuilder: FormBuilder) {
    super();
  }

  ngAfterViewInit() {
    this.paramsChangeSubsc = this.paramsChange.subscribe(
      (changes: SimpleChanges) => {
        if (changes.params) {
          this.form.get('threshold').setValue(changes.params.currentValue.threshold);
          this.form.get('period').setValue(changes.params.currentValue.period);
          this.form.get('type').setValue(changes.params.currentValue.type);
          this.form.get('hysteresis').setValue(changes.params.currentValue.hysteresis);
          this.form.get('channel').setValue(changes.params.currentValue.channel);
        }
      });
  }

  ngOnDestroy() {
    this.paramsChangeSubsc.unsubscribe();
  }

  mapAlarmParamsToForm() {
    this.params = this.params ? this.params : new StaticThresholdAlarmParameters();
    const integerValidator = (control: AbstractControl) => isNaN(control.value) ? {'not a number': true} : null;
    this.form = this.formBuilder.group({
        threshold: [{value: this.params.threshold, disabled: this.readOnly}, [Validators.required, integerValidator]],
        period: [{value: this.params.period, disabled: this.readOnly}, [Validators.required, Validators.pattern('[1-9]*')]],
        type: [{value: this.params.type, disabled: this.readOnly}, [Validators.required]],
        hysteresis: [{value: this.params.hysteresis, disabled: this.readOnly}, [Validators.required, integerValidator]],
        channel: [{value: this.params.channel, disabled: this.readOnly}, [Validators.pattern('[0-1]*')]]
      }
    );
  }
}
